import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="early-access"
export default class extends Controller {
  static targets = ["dialog"];
  static values = { show: Boolean };

  connect() {
    if (this.showValue) {
      this.open();
    }
  }

  open() {
    this.dialogTargets.forEach((target) => {
      target.showModal();
    });
  }

  close() {
    this.dialogTargets.forEach((target) => {
      target.close();
    });
  }
}
